import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import React, { FC, useCallback, useEffect, useState } from 'react';
import authService from '../../auth/service/AuthService';
import {
  // CustomSwitch,
  NavbarTheme,
  useAppDispatch,
  useAppSelector,
  useScreenSize,
} from '../../globalUtils/globalExports';
import localStorageInstance from '../../rmsReduxStore/api-service/LocalStorageService';
import { SidebarPropTypes } from '../AppLayout';
import { Arrow } from '../../globalUtils/globalIcons';
import rmsStore from '../../rmsReduxStore/rmsStore';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { getGlobalReducer, getRmsAlertDetails } from '../../rmsReduxStore/reduxExports';
// import { persistor } from '../../rmsReduxStore/rmsStore';
import { Icon } from '../../globalUtils/globalIcons';
import { rmsSupportCenterTypes } from '../../rmsReduxStore/reduxExports';
import access from '../../auth/service/AccessControl';
import { setAcAndDcToggleState } from '../../rmsReduxStore/globalRedux/globalCreators';
import ACDCToggle from '../../globalUtils/ACDCToggle/ACDCToggle';
import './navbar.css';


export interface IUser {
  email_address: string;
  id: string;
  mobile_number: string;
  name: string;
  role_id: string;
}

interface IRmsAlertData{ 
  show: boolean,
  message: string
}

// const rmsSupportCenterAccess = ['f1b61727-2cbf-4a95-9760-be993796489b','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7257','de227ed8-9e35-4c45-a04d-5af10a6d850f','aefdba75-9d7d-4e9d-aab9-86f2944aad46','e9b21cf0-cc25-4474-a279-04616a0d78f1','93b19d88-6799-48aa-ac27-02b4e4fb93f9','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7246']

const Navbar: FC<SidebarPropTypes> = (props) => {
  const { expandSideBar, handleSidebarToggle } = props;
  const screenSize = useScreenSize?.();
  const [anchorEl, setAnchorEl] = useState(null);
  const [userDetails, setUserDetails] = useState<IUser | null>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const rmsSupportCentreSubScreens = ['/help-and-faq-dashboard','/rms-support-center','/help-and-faq','/rms-support-center/chat','/troubleshooting','/documentation','/add-document'];
  const {hideSideBar,acAndDcToggleState} = useAppSelector(getGlobalReducer);
  const [acAndDcToggle, setAcAndDcToggle] = useState(acAndDcToggleState);
  const hasAccessToAcAndDc= access?.acAndDcAccess();
  const [rmsAlertData, setRmsAlertData] = useState<IRmsAlertData>({
    show: false,
    message: ''
  })

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleMenu = (event): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleSideBar = useCallback(() => {
    handleSidebarToggle?.(!expandSideBar);
  }, [expandSideBar, handleSidebarToggle]);

  const handleAcAndDcToggle =(val:string) => {
    setAcAndDcToggle(val)
   dispatch(setAcAndDcToggleState(val));
  };

   const fetchDowntime = useCallback(async () => {
      const response = await getRmsAlertDetails();
      if(response?.status === 'SUCCESS') {
        setRmsAlertData({
          show: response?.data?.showBanner,
          message: response?.data?.message
        })
      }
    }, [])

  useEffect(() => {
    fetchDowntime(); 
  
    const interval = setInterval(() => {
      fetchDowntime();
    }, 30000); 
  
    return () => clearInterval(interval); // cleanup
  }, []);

  useEffect(() => {
    const user = localStorageInstance.fetchUser();
    setUserDetails(user);
    if(!acAndDcToggleState){
      dispatch(setAcAndDcToggleState(access?.acAndDcAccess()==='AC'? 'AC' :'DC'));
    }
  }, []);

  const handleUserLogout = async (): Promise<void> => {
    const user = localStorageInstance?.fetchUser();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const res = await authService.handleLogout({
      userId: user?.id,
      sessionId: localStorage?.getItem('sessionId'),
    });

      localStorage.clear();
      // DISPATCHING RESET ACTION TO CLEAR THE PERSISTED REDUX STORE 
      // AFTER CLEARING LOCAL STORAGE WINDOW RELOAD WON'T WORK AS IT HAS BEEN OVERRIDED BY REDUX PERSIST
      rmsStore.dispatch({type: 'RESET_LOGOUT'})
      window.location.reload();
      handleClose();
  };

  return (
    <ThemeProvider theme={NavbarTheme}>
      <AppBar
        style={{ background: 'var(--navbar-color)', height: '48px' }}
        position="fixed"
        component={'div'}
      >
        <Toolbar disableGutters={true} variant="dense">
          <div className="app__navbar__left">
            {
              !hideSideBar && <IconButton
                size="small"
                edge="start"
                color="inherit"
                aria-label="menu"
                style={{ marginRight: 12 }}
                onClick={() => handleSideBar()}
              >
                <div
                  className={
                    screenSize?.width <= 800 && expandSideBar
                      ? 'navbar__close__icon rms__icon'
                      : 'navbar__expand__collapse__icon rms__icon'
                  }
                ></div>
              </IconButton>
            }
            <IconButton
              size="small"
              edge="start"
              color="inherit"
              aria-label="menu"
              style={{ marginRight: 0,cursor: 'default' }}
              // onClick={() => handleSideBar()}
            >
              <div className="rms__icon harmony-connect-icon"></div>
            </IconButton>
          </div>

          {rmsAlertData?.show && (
              <div className="downntime_details">
                <div className="marquee">
                  <div className="marquee__track">
                    <span>{rmsAlertData?.message}</span>
                    <span>{rmsAlertData?.message}</span>
                    <span>{rmsAlertData?.message}</span>
                  </div>
                </div>
              </div>
            )}

          <div className="app__navbar__right">
            {/* Here To have toggle button to switch between AC And DC Tab */}
            { hasAccessToAcAndDc && hasAccessToAcAndDc ==='All' ? <>
            <div style={{paddingRight:'5px',display:'flex', gap:'10px'}}>
              <ACDCToggle selected={acAndDcToggle ?acAndDcToggle : 'DC'} onChange={() => { handleAcAndDcToggle(acAndDcToggle==='DC' ? 'AC': 'DC' )}} />
            </div>
            </> : 
             (<></>)
              }
            {
              access?.aiSupportCenter?.aiSupportCenterChatBot?.view() && <IconButton 
             size="small"
             aria-label="rms support center button"
             style={{ marginRight: 12,cursor: 'pointer' }}
             onClick={()=>{
              const action = {
                type: rmsSupportCenterTypes.CLEAR_RMS_SUPPORT_SEARCH_QUERY_RESPONSE,
              }
              dispatch(action)
              navigate('/rms-support-center')
             }}
            >
              <div className='navbar__rms__support__center__btn' 
              style={{backgroundColor:rmsSupportCentreSubScreens?.some(path => matchPath({ path, end: false }, location.pathname))? 'var(--secondary-blue-color)' : '#003E48',borderRadius:'70px',padding:'4px 12px 4px 8px',display:'flex',gap:'4px'}}>
                <Icon iconClassName='rms__support__icon' />
                <Typography
                variant="h6"
                component="div"
                sx={{
                  fontSize: '13px',
                  fontWeight: 500,
                  fontFamily: 'var(--font-family)',
                  color:'var(--primary-white-color)'
                }}
                className="navbar__profile__name"
              >
                AI Smart Assist
              </Typography>
              </div>
            </IconButton>
            }
            {/* <IconButton
              size="small"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              color="inherit"
            >
              <div className="navbar__settings__icon rms__icon"></div>
            </IconButton> */}
            <div className="app__navbar__profile" onClick={handleMenu}>
              <IconButton
                size="small"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
              >
                <div className="navbar__profile__icon rms__icon"></div>
              </IconButton>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontSize: '13px',
                  marginTop: '1px',
                  fontWeight: 300,
                  fontFamily: 'var(--font-family)',
                  marginRight: '5px',
                }}
                className="navbar__profile__name"
              >
                {userDetails && userDetails?.name}
              </Typography>
              <div className="navbar__profile__arrows__wrap">
                <IconButton
                  size="small"
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                >
                  {anchorEl ? (
                    <Arrow color={'white'} direction={'up'} />
                  ) : (
                    <Arrow color={'white'} direction={'down'} />
                  )}
                </IconButton>
              </div>
            </div>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              sx={{ top: '30px' }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              classes={{ list: 'profile__list' }}
            >
              <MenuItem onClick={handleClose}>
                <IconButton
                  size="small"
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  sx={{ mr: 2 }}
                >
                  <div className="rms__icon navbar__avatar__icon"></div>
                </IconButton>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ fontSize: '14px' }}
                >
                  My Profile
                </Typography>
              </MenuItem>
              <MenuItem onClick={handleUserLogout}>
                <IconButton
                  size="small"
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  sx={{ mr: 2 }}
                >
                  <div className="rms__icon navbar__logout__icon"></div>
                </IconButton>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ fontSize: '14px' }}
                  onClick={() => { }}
                >
                  Logout
                </Typography>
              </MenuItem>
            </Menu>
            
            <div className="rms__exicom__logo__icon rms__icon"
              style={
                {marginLeft:12}
              }
            ></div>
          </div>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
};
export default Navbar;
